import React, { useEffect } from "react";
import "./Menu.css";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import tg from "../../api/tg";
import { translations, normalizeLang } from "../../i18n";

const Menu = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  useEffect(() => {
    const menu = document.querySelector(".menuContainer");
    if (!menu) return;

    const toggleMenu = () => {
      const el = document.activeElement;

      const shouldHide =
        ["INPUT", "TEXTAREA"].includes(el?.tagName) &&
        !el?.classList.contains("shop__search");

      menu.style.transform = shouldHide ? "translateY(100%)" : "translateY(0)";
    };

    const handleFocusOut = (e) => {
      setTimeout(() => {
        const el = document.activeElement;
        if (!["INPUT", "TEXTAREA"].includes(el?.tagName) || el?.classList.contains("shop__search")) {
          menu.style.transform = "translateY(0)";
        }
      }, 100);
    };

    window.addEventListener("resize", toggleMenu);
    window.addEventListener("focusin", toggleMenu);
    window.addEventListener("focusout", handleFocusOut);

    toggleMenu();

    return () => {
      window.removeEventListener("resize", toggleMenu);
      window.removeEventListener("focusin", toggleMenu);
      window.removeEventListener("focusout", handleFocusOut);
    };
  }, []);

  useEffect(() => {
    const menu = document.querySelector(".menuContainer");
    if (!menu) return;

    const el = document.activeElement;
    const shouldHide =
      ["INPUT", "TEXTAREA"].includes(el?.tagName) &&
      !el?.classList.contains("shop__search");

    if (!shouldHide) {
      menu.style.transform = "translateY(0)";
    }
  }, [location.pathname]);

  return (
    <div className="menuContainer">
      <Link
        to={"/"}
        onClick={() => {
          tg.HapticFeedback.impactOccurred("light");
        }}
        className="menuIconContainer"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.16667 0C0.522667 0 0 0.522667 0 1.16667C0 1.81067 0.522667 2.33333 1.16667 2.33333H19.8333C20.4773 2.33333 21 1.81067 21 1.16667C21 0.522667 20.4773 0 19.8333 0H1.16667ZM3.5 4.66667C1.56683 4.66667 0 6.2335 0 8.16667V12.8333C0 14.7665 1.56683 16.3333 3.5 16.3333H17.5C19.4332 16.3333 21 14.7665 21 12.8333V8.16667C21 6.2335 19.4332 4.66667 17.5 4.66667H3.5ZM3.5 7H17.5C18.144 7 18.6667 7.52267 18.6667 8.16667V12.8333C18.6667 13.4773 18.144 14 17.5 14H3.5C2.856 14 2.33333 13.4773 2.33333 12.8333V8.16667C2.33333 7.52267 2.856 7 3.5 7ZM1.16667 18.6667C0.522667 18.6667 0 19.1893 0 19.8333C0 20.4773 0.522667 21 1.16667 21H19.8333C20.4773 21 21 20.4773 21 19.8333C21 19.1893 20.4773 18.6667 19.8333 18.6667H1.16667Z"
            fill={currentPath === "/" ? "#366091" : "black"}
            opacity={currentPath === "/" ? 1 : 0.4}
          />
        </svg>
        <p
          className="menuP"
          style={{ opacity: currentPath === "/" ? 0.85 : 0.4 }}
        >
          {t.home}
        </p>
      </Link>

      {/* <Link
        to={"/shop"}
        onClick={() => {
          tg.HapticFeedback.impactOccurred("light");
        }}
        className="menuIconContainer"
      >
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 17.2C2 15.737 2 15.0055 2.32965 14.4678C2.51395 14.1666 2.76665 13.9139 3.0678 13.7296C3.60455 13.4 4.337 13.4 5.8 13.4C7.263 13.4 7.9945 13.4 8.5322 13.7296C8.83335 13.9139 9.08605 14.1666 9.27035 14.4678C9.6 15.0045 9.6 15.737 9.6 17.2C9.6 18.663 9.6 19.3945 9.27035 19.9332C9.08605 20.2334 8.83335 20.486 8.5322 20.6703C7.99545 21 7.263 21 5.8 21C4.337 21 3.6055 21 3.0678 20.6703C2.76698 20.4864 2.51403 20.2337 2.32965 19.9332C2 19.3945 2 18.663 2 17.2ZM13.4 17.2C13.4 15.737 13.4 15.0055 13.7296 14.4678C13.9139 14.1666 14.1666 13.9139 14.4678 13.7296C15.0045 13.4 15.737 13.4 17.2 13.4C18.663 13.4 19.3945 13.4 19.9332 13.7296C20.2334 13.9139 20.486 14.1666 20.6703 14.4678C21 15.0045 21 15.737 21 17.2C21 18.663 21 19.3945 20.6703 19.9332C20.486 20.2334 20.2334 20.486 19.9332 20.6703C19.3945 21 18.663 21 17.2 21C15.737 21 15.0055 21 14.4678 20.6703C14.167 20.4864 13.914 20.2337 13.7296 19.9332C13.4 19.3945 13.4 18.663 13.4 17.2ZM2 5.8C2 4.337 2 3.6055 2.32965 3.0678C2.51395 2.76665 2.76665 2.51395 3.0678 2.32965C3.60455 2 4.337 2 5.8 2C7.263 2 7.9945 2 8.5322 2.32965C8.83335 2.51395 9.08605 2.76665 9.27035 3.0678C9.6 3.60455 9.6 4.337 9.6 5.8C9.6 7.263 9.6 7.9945 9.27035 8.5322C9.08605 8.83335 8.83335 9.08605 8.5322 9.27035C7.99545 9.6 7.263 9.6 5.8 9.6C4.337 9.6 3.6055 9.6 3.0678 9.27035C2.76687 9.08609 2.51391 8.83313 2.32965 8.5322C2 7.99545 2 7.263 2 5.8ZM13.4 5.8C13.4 4.337 13.4 3.6055 13.7296 3.0678C13.9139 2.76665 14.1666 2.51395 14.4678 2.32965C15.0045 2 15.737 2 17.2 2C18.663 2 19.3945 2 19.9332 2.32965C20.2334 2.51395 20.486 2.76665 20.6703 3.0678C21 3.60455 21 4.337 21 5.8C21 7.263 21 7.9945 20.6703 8.5322C20.486 8.83335 20.2334 9.08605 19.9332 9.27035C19.3945 9.6 18.663 9.6 17.2 9.6C15.737 9.6 15.0055 9.6 14.4678 9.27035C14.1669 9.08609 13.9139 8.83313 13.7296 8.5322C13.4 7.99545 13.4 7.263 13.4 5.8Z"
            stroke={currentPath === "/shop" ? "#366091" : "black"}
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity={currentPath === "/shop" ? 1 : 0.4}
          />
        </svg>
        <p
          className="menuP"
          style={{ opacity: currentPath === "/shop" ? 0.85 : 0.4 }}
        >
          {t.menu}
        </p>
      </Link> */}

      <Link
        to={"/reservation"}
        onClick={() => {
          tg.HapticFeedback.impactOccurred("light");
        }}
        className="menuIconContainer"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.41838 0C1.97833 0 0 2.0895 0 4.66667V16.3333C0 18.9105 1.97833 21 4.41838 21H15.4643C17.9044 21 19.8827 18.9105 19.8827 16.3333V11.6667C19.8827 11.0227 19.3879 10.5 18.7781 10.5C18.1684 10.5 17.6735 11.0227 17.6735 11.6667V16.3333C17.6735 17.6225 16.6849 18.6667 15.4643 18.6667H4.41838C3.1978 18.6667 2.20919 17.6225 2.20919 16.3333V4.66667C2.20919 3.3775 3.1978 2.33333 4.41838 2.33333H13.2551C13.8649 2.33333 14.3597 1.81067 14.3597 1.16667C14.3597 0.522667 13.8649 0 13.2551 0H4.41838ZM19.8827 1.16667C19.5999 1.16667 19.3039 1.27167 19.0885 1.49451L9.45754 11.4847C9.17366 11.7798 8.88756 11.7588 8.66444 11.4112L7.55984 9.69735C7.22184 9.17118 6.5127 9.01834 6.00679 9.36951C5.49978 9.72067 5.35729 10.4475 5.6953 10.9737L6.79989 12.6875C7.79513 14.238 9.74252 14.4433 11.0117 13.125L20.6769 3.09867C21.1077 2.65184 21.1077 1.94251 20.6769 1.49451C20.4615 1.27051 20.1655 1.16667 19.8827 1.16667Z"
            fill={currentPath === "/reservation" ? "#366091" : "black"}
            opacity={currentPath === "/reservation" ? 1 : 0.4}
          />
        </svg>
        <p
          className="menuP"
          style={{ opacity: currentPath === "/reservation" ? 0.85 : 0.4 }}
        >
          {t.reservation}
        </p>
      </Link>

      <Link
        to={"/info"}
        onClick={() => {
          tg.HapticFeedback.impactOccurred("light");
        }}
        className="menuIconContainer"
      >
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 0C4.70106 0 0 4.70085 0 10.5C0 16.2991 4.70106 21 10.5 21C16.2989 21 21 16.2991 21 10.5C21 4.70085 16.2989 0 10.5 0ZM10.5 2.1C15.1392 2.1 18.9 5.8611 18.9 10.5C18.9 15.1389 15.1392 18.9 10.5 18.9C5.86078 18.9 2.1 15.1389 2.1 10.5C2.1 5.8611 5.86078 2.1 10.5 2.1ZM10.5 5.25C9.92008 5.25 9.45 5.7204 9.45 6.3C9.45 6.8796 9.92008 7.35 10.5 7.35C11.0799 7.35 11.55 6.8796 11.55 6.3C11.55 5.7204 11.0799 5.25 10.5 5.25ZM10.5 8.4C9.92008 8.4 9.45 8.8704 9.45 9.45V14.7C9.45 15.2796 9.92008 15.75 10.5 15.75C11.0799 15.75 11.55 15.2796 11.55 14.7V9.45C11.55 8.8704 11.0799 8.4 10.5 8.4Z"
            fill={currentPath === "/info" ? "#366091" : "black"}
            opacity={currentPath === "/info" ? 1 : 0.4}
          />
        </svg>
        <p
          className="menuP"
          style={{ opacity: currentPath === "/info" ? 0.85 : 0.4 }}
        >
          {t.faq}
        </p>
      </Link>
    </div>
  );
};

export default Menu;
